export enum BUTTON_TYPES {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  OUTLINED = 'outlined',
  SQUARE = 'square',
  SECONDARY_LINK = 'secondaryLink',
  INACTIVE = 'inactive',
}

export enum BUTTON_SIZE {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  SQUARE = 'square',
}
